/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var BookmarkIcon20Light = forwardRef('BookmarkIcon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4 5a3 3 0 0 1 3-3h6a3 3 0 0 1 3 3v11.486c0 1.203-1.344 1.916-2.34 1.243l-3.38-2.286a.5.5 0 0 0-.56 0l-3.38 2.286c-.996.673-2.34-.04-2.34-1.243V5Zm3-2a2 2 0 0 0-2 2v11.486a.5.5 0 0 0 .78.414l3.38-2.286a1.5 1.5 0 0 1 1.68 0l3.38 2.286a.5.5 0 0 0 .78-.414V5a2 2 0 0 0-2-2H7Z" })));
});
